export const SET = 'billing/SET';
export const CLEAR_PAGE_DATA = 'billing/CLEAR_PAGE_DATA';
